module.exports = __webpack_public_path__ + "DINNextLTPro-Regular.woff?c968fc086f1faad42263b81827f816dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Regular.woff
// module id = 1377
// module chunks = 0